/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ILoadingMethods,
  LoadingService,
  ICreateCampaignMethods,
  CreateCampaignService,
} from './components';

export type NewCampaignPageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  ICreateCampaignMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new CreateCampaignService(),
    new StaticPageContentService(),
    new LoadingService(),
  ];
};

export const getAgent = () => {
  return createAgent<NewCampaignPageAgent>({
    plugins: getPlugins(),
  });
};
